import React, { useState, useEffect } from 'react';
import './Navbar.scss';

const Navbar = ({ isDarkMode }) => {
    const [showNavbar, setShowNavbar] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setShowNavbar(true);
        }, 7800);
    }, []);

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            if (sectionId === 'numbers' && window.innerWidth > 770) {
                const elementRect = element.getBoundingClientRect();
                const absoluteElementTop = elementRect.top + window.scrollY;
                const middle = absoluteElementTop - (window.innerHeight / 2);
                window.scrollTo({ top: middle, behavior: 'smooth' });
            } else {
                element.scrollIntoView({ behavior: 'smooth' });
            }
            // Close mobile menu after clicking
            setIsMobileMenuOpen(false);
        }
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <nav className={`navbar-container ${isDarkMode ? 'dark' : 'light'} ${showNavbar ? 'show' : ''}`}>
            <div className="nav-buttons">
                <a onClick={() => scrollToSection('numbers')}>Stats</a>
                <a onClick={() => scrollToSection('experiences')}>Experience</a>
                <a onClick={() => scrollToSection('projects')}>Projects</a>
                <a onClick={() => scrollToSection('contact')}>Contact</a>
            </div>
            
            {/* Hamburger Icon */}
            <div 
                className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`} 
                onClick={toggleMobileMenu}
            >
                <div className="line"></div>
                <div className="line"></div>
                <div className="line"></div>
            </div>
            
            {/* Mobile Menu */}
            <div className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
                <a onClick={() => scrollToSection('numbers')}>Stats</a>
                <a onClick={() => scrollToSection('experiences')}>Experience</a>
                <a onClick={() => scrollToSection('projects')}>Projects</a>
                <a onClick={() => scrollToSection('contact')}>Contact</a>
            </div>
        </nav>
    );
};

export default Navbar;

